import { Container, Row, Col } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { getTimeInOut } from '../../../services/ApiGetTimeInOut';
import Moment from 'moment';
import { useTranslation } from 'react-i18next';
import { TimeInOut } from '../../../model/datatype';

export const TimeInOutThisWeek = (props: any) => {
  let { t } = useTranslation();
  const [data, setData] = useState<TimeInOut | null>(null);

  useEffect(() => {
    if (data === null) {
      getTimeInOut(0, 0, props.email).then((response: any) => {
        const getData: any = response;
        setData(getData);
      });
    }
  }, [data]);

  return (
    <div className="TimeInout_ThisWeek_detail text-center">
      <Row className="m-auto">
        <Col className="px-1">
          <div className="TimeInout_ThisWeek_detail_box">
            <div className="TimeInout_ThisWeek_detail_text">
              {/* <img src="../images/arrow-left.png" className="arrow-left" alt="arrow left"  width={14} onClick={()=>setCount(count-5)} /> */}
              {t('time_list_box.timeanddate_in_out.title')}
              {/* <img src="../images/arrow-right.png" className="arrow-right" alt="arrow left"  width={14} onClick={()=>setCount(count-5)} /> */}
            </div>
            <Row className="this-week-title-box m-1">
              <Col className="this-week-title px-1">
                {t('time_list_box.timeanddate_in_out.date')}
              </Col>
              <Col className="this-week-title px-1">
                {t('time_list_box.timeanddate_in_out.timein')}
              </Col>
              <Col className="this-week-title px-1">
                {t('time_list_box.timeanddate_in_out.timeout')}
              </Col>
              <Col className="this-week-title px-1">
                {t('time_list_box.timeanddate_in_out.time_absence')}
              </Col>
              <Col className="this-week-title px-1">
                {t('time_list_box.timeanddate_in_out.overtime')}
              </Col>
            </Row>
            <div className="w-100 table-container">
              {typeof data?.timeInOutDetailInfos !== 'undefined' ? (
                data?.timeInOutDetailInfos.length > 0 ? (
                  data?.timeInOutDetailInfos.map((item: any, index: number) => (
                    <Row
                      className={`time-in-out-list ${
                        item.qtyOT > 0 ? 'active1' : ' '
                      } ${item.qtyAbs > 0 ? 'active2' : ' '} m-1 mt-3`}
                      key={index}
                    >
                      <Col className="this-week-title-val px-1">
                        {Moment(item.dateWork).format('DD/M/YYYY')}
                      </Col>
                      <Col className="this-week-title-val px-1">
                        {item.timeIn ? item.timeIn : '-'}
                      </Col>
                      <Col className="this-week-title-val px-1">
                        {item.timeOut ? item.timeOut : '-'}
                      </Col>
                      <Col className="this-week-title-val px-1">
                        {item.qtyAbsStr ? item.qtyAbsStr : '-'}
                      </Col>
                      <Col className="this-week-title-val px-1">
                        {item.qtyOTStr ? item.qtyOTStr : '-'}
                      </Col>
                    </Row>
                  ))
                ) : (
                  <div className="loader-data? text-notfound">
                    {t('text_notfound')}
                  </div>
                )
              ) : (
                <div className="loader-data">
                  <div className="spinner"></div>
                </div>
              )}
            </div>
            <Row className="time-in-out-list line-total m-1 mt-3">
              <Col
                xs={8}
                className="this-week-title-val px-1  text-left"
                style={{ textAlign: 'left' }}
              >
                <strong className="time-in-out-this-week-total text-left">
                  {t('time_list_box.timeanddate_in_out.total')}
                </strong>
              </Col>
              <Col
                xs={4}
                className="this-week-title-val px-1  text-right pb-0"
                style={{ textAlign: 'right' }}
              >
                <strong className="time-in-out-this-week-total">
                  {data?.summary} {t('time_list_box.timeanddate_in_out.unit')}
                </strong>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
      <Row>
        <Col className="m-2"></Col>
      </Row>
    </div>
  );
};
